import React from 'react'

const ClockIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="clockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(150, 100, 255, 1)" />
          <stop offset="100%" stopColor="rgba(255, 100, 200, 1)" />
        </linearGradient>
        <filter id="clockGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Clock circle */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="url(#clockGradient)"
        strokeWidth="2"
        fill="rgba(150, 100, 255, 0.1)"
        filter="url(#clockGlow)"
      />
      
      {/* Hour hand */}
      <line
        x1="12"
        y1="12"
        x2="12"
        y2="7"
        stroke="url(#clockGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Minute hand */}
      <line
        x1="12"
        y1="12"
        x2="16"
        y2="12"
        stroke="url(#clockGradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      
      {/* Center dot */}
      <circle cx="12" cy="12" r="1.5" fill="rgba(255, 100, 200, 1)" />
      
      {/* Hour markers */}
      <circle cx="12" cy="5" r="0.8" fill="rgba(150, 100, 255, 0.6)" />
      <circle cx="19" cy="12" r="0.8" fill="rgba(150, 100, 255, 0.6)" />
      <circle cx="12" cy="19" r="0.8" fill="rgba(150, 100, 255, 0.6)" />
      <circle cx="5" cy="12" r="0.8" fill="rgba(150, 100, 255, 0.6)" />
    </svg>
  )
}

export default ClockIcon
